import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";
import { serverResponseFormat } from "@similarweb/pro-logic-components";
import dayjs from "dayjs";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export interface IPoint {
    color: string;
    name: string;
    value: number;
    date?: string;
    key?: number;
}
interface AnnotationProps {
    text: string;
}
const Annotation = styled(FlexColumn)``;

const BellText = styled.span`
    margin-left: 10px;
    padding-right: 10px;
    white-space: normal;
    width: calc(100% - 20px);
    ${setFontVariant("report", colorsPalettes.carbon[300])};
`;

const Marker = styled(FlexRow)`
    width: 20px;
    height: 19px;
    border-radius: 50%;
    background-color: ${colorsPalettes.blue[400]};
    align-items: start;
    justify-content: center;
`;

const BellContentWrapper = styled(FlexRow)`
    background-color: ${colorsPalettes.orange[100]};
    height: 44px;
    margin-top: 16px;
    align-items: center;
    padding-left: 13px;
    border-radius: 4px;
`;

const StyledAlertIcon = styled(SWReactIcons)`
    margin-top: 3px;
    height: 12px;
    width: 12px;
`;
export const getAnnotationDateForGranularity = (currentDate: string, granularity: GranularityNames): string => {
    const date = dayjs(currentDate);
    switch (granularity) {
        case GranularityNames.DAILY:
            return date.format(serverResponseFormat);
        case GranularityNames.MONTHLY:
            return date.startOf("month").format(serverResponseFormat);
        case GranularityNames.WEEKLY:
            return date.startOf("week").format(serverResponseFormat);
        default:
            return date.format(serverResponseFormat);
    }
};

export const displayAnnotation = (points: IPoint[], text: string, dateForAnnotation: string) => {
    const dateForAnnotationUTC = dayjs.utc(dateForAnnotation).format(serverResponseFormat);
    const areDatesValid = points.every((point) => {
        const newPoint = point.date ?? point.key;
        const pointDateUTC = dayjs.utc(newPoint).format(serverResponseFormat);
        return pointDateUTC === dateForAnnotationUTC;
    });
    return areDatesValid ? <AnnotationBanner text={text} /> : undefined;
};

const AnnotationBanner: React.FC<AnnotationProps> = ({ text }) => {
    return (
        <Annotation>
            <BellContentWrapper>
                <Marker>
                    <StyledAlertIcon
                        iconColor={colorsPalettes.carbon[0]}
                        iconName="alerts"
                    />
                </Marker>
                <BellText>{text}</BellText>
            </BellContentWrapper>
        </Annotation>
    );
};
